module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-end-btn-2d30e38e.svg";